import idlImport from './locker.did.js';
export const idlFactory = idlImport;
export const canisterId = "bicha-4aaaa-aaaah-aaidq-cai";
